export enum WindBraceStyle {
  None = 'none',
  Cross = 'cross',
  ZigZag = 'zig-zag',
}
